export function formatFloat64Check(check) {
  const forbidden = [];
  if (!check.allowNaN) {
    forbidden.push("NaN");
  }
  if (!check.allowInfinity) {
    forbidden.push("-Infinity");
    forbidden.push("+Infinity");
  }
  if (!check.allowNegativeZero) {
    forbidden.push("-0");
  }
  if (forbidden.length === 0) {
    return "value must be Float64";
  } else {
    return `value must be Float64 except ${forbidden.join(" | ")}`;
  }
}
